/**
 * Волна A (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/500'>.
 * PrivateRoute для путей вне /cabinet и /bar-menu сводится к CacheDataRoute.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import NotAvailable500 from '@routes/StaticPages/ErrorPages/NotAvailable500';

export const Route = createFileRoute('/500')({
  component: () => (
    <CacheDataRoute component={NotAvailable500} path='/500' />
  )
});
